import { TourType } from "./TourType";
import { QuoteRequestShipment } from "./QuoteRequestShipment";
import { BookDirectOrder } from "../../features/bookDirect/model/BookDirectOrder";
import { BookMultiOrder } from "../../features/bookMulti/model/BookMultiOrder";

export class QuoteRequest {
  tourType: TourType;
  shipments: QuoteRequestShipment[];

  constructor(tourType: TourType, shipments: QuoteRequestShipment[]) {
    this.tourType = tourType;
    this.shipments = shipments;
  }

  static requestForDirectOrder = (order: BookDirectOrder): QuoteRequest => {
    return new QuoteRequest(TourType.Direct, [
      QuoteRequestShipment.shipmentForDirectOrder(order)
    ]);
  };

  static requestForMultiOrder = (order: BookMultiOrder): QuoteRequest => {
    if (!order.date) throw new Error("validation failed: date missing");
    const shipments = order.multiPoints.map(mp => {
      const startAddress =
        order.type! === TourType.Distribution
          ? order.singlePoint.address
          : mp.address;
      const endAddress =
        order.type! === TourType.Distribution
          ? mp.address
          : order.singlePoint.address;
      const startWindow =
        order.type! === TourType.Distribution
          ? order.singlePoint.timewindow
          : mp.timewindow;
      const endWindow =
        order.type! === TourType.Distribution
          ? mp.timewindow
          : order.singlePoint.timewindow;
      return new QuoteRequestShipment(
        startAddress,
        endAddress,
        order.date!,
        startWindow,
        endWindow,
        mp.loads,
        order.extras
      );
    });
    return new QuoteRequest(order.type!, shipments);
  };
}
